export const ROUTE_PATH = '/';
